<template>
  <div class="notification-record-page">
    <el-card shadow="never">
      <div slot="header" class="card-title">短信记录</div>

      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item label="自定义检索">
          <el-select value="mobile" disabled class="search-type">
            <el-option label="手机号" value="mobile" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model.trim="searchForm.mobile"
            clearable
            maxlength="100"
            placeholder="手机号"
            @keyup.enter.native="handleSearch"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">
            搜索
          </el-button>
          <el-button icon="el-icon-refresh" @click="handleReset"
            >重置</el-button
          >
          <el-button
            type="success"
            icon="el-icon-download"
            :loading="exporting"
            @click="handleExport"
          >
            导出Excel
          </el-button>
        </el-form-item>
      </el-form>

      <el-table v-loading="loading" :data="tableData" border stripe>
        <el-table-column type="index" label="序号" width="70" align="center" />
        <el-table-column
          prop="mobile"
          label="手机号"
          min-width="150"
          align="center"
        />
        <el-table-column
          prop="code"
          label="短信验证码"
          min-width="120"
          align="center"
        />
        <el-table-column
          prop="content"
          label="短信内容"
          min-width="300"
          show-overflow-tooltip
        />
        <el-table-column
          prop="template"
          label="短信主题"
          min-width="150"
          show-overflow-tooltip
        />
        <el-table-column label="是否发送成功" width="130" align="center">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.success ? 'success' : 'danger'"
              size="small"
            >
              {{ formatSuccess(scope.row.success) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="created_at"
          label="创建时间"
          width="180"
          align="center"
          :formatter="formatTableDate"
        />
        <el-table-column
          prop="expired_at"
          label="失效时间"
          width="180"
          align="center"
          :formatter="formatTableDate"
        />
      </el-table>

      <div class="pagination-wrapper">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
          :page-sizes="[10, 15, 20, 25]"
          :page-size="pagination.pageSize"
          :current-page="pagination.currentPage"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import ExportJsonExcel from "js-export-excel";
import { getSmsRecordList } from "@/api/notification";
import { formatDate } from "@/utils/formatter";

export default {
  name: "SmsRecords",
  data() {
    return {
      loading: false,
      exporting: false,
      tableData: [],
      searchForm: {
        mobile: ""
      },
      pagination: {
        currentPage: 1,
        pageSize: 15,
        total: 0
      }
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    buildParams(withPagination = true) {
      const params = {};
      if (this.searchForm.mobile) params.mobile = this.searchForm.mobile;
      if (withPagination) {
        params.page = this.pagination.currentPage;
        params.rows = this.pagination.pageSize;
      }
      return params;
    },
    async fetchData() {
      this.loading = true;
      try {
        const res = await getSmsRecordList(this.buildParams());
        this.tableData = (res && res.rows) || [];
        this.pagination.total = Number((res && res.total) || 0);
      } finally {
        this.loading = false;
      }
    },
    handleSearch() {
      this.pagination.currentPage = 1;
      this.fetchData();
    },
    handleReset() {
      this.searchForm.mobile = "";
      this.pagination.currentPage = 1;
      this.pagination.pageSize = 15;
      this.fetchData();
    },
    handleSizeChange(pageSize) {
      this.pagination.pageSize = pageSize;
      this.pagination.currentPage = 1;
      this.fetchData();
    },
    handleCurrentChange(currentPage) {
      this.pagination.currentPage = currentPage;
      this.fetchData();
    },
    async handleExport() {
      this.exporting = true;
      try {
        const res = await getSmsRecordList(this.buildParams(false));
        const rows = (res && res.rows) || [];
        if (!rows.length) {
          this.$message.warning("没有可导出的短信记录");
          return;
        }
        const sheetData = rows.map(item => ({
          手机号: item.mobile || "",
          短信验证码: item.code || "",
          短信内容: item.content || "",
          短信主题: item.template || "",
          是否发送成功: this.formatSuccess(item.success),
          创建时间: this.formatDateValue(item.created_at),
          失效时间: this.formatDateValue(item.expired_at)
        }));
        new ExportJsonExcel({
          fileName: "短信记录",
          datas: [
            {
              sheetData,
              sheetName: "短信记录",
              sheetHeader: [
                "手机号",
                "短信验证码",
                "短信内容",
                "短信主题",
                "是否发送成功",
                "创建时间",
                "失效时间"
              ]
            }
          ]
        }).saveExcel();
      } finally {
        this.exporting = false;
      }
    },
    formatSuccess(value) {
      return value ? "成功" : "失败";
    },
    formatTableDate(row, column, cellValue) {
      return this.formatDateValue(cellValue);
    },
    formatDateValue(value) {
      if (!value) return "";
      const normalized =
        typeof value === "number" && value < 1000000000000
          ? value * 1000
          : value;
      return formatDate(normalized);
    }
  }
};
</script>

<style lang="less" scoped>
.notification-record-page {
  padding: 20px;
}

.card-title {
  font-size: 16px;
  font-weight: 600;
}

.search-form {
  margin-bottom: 4px;
}

.search-type {
  width: 150px;
}

.pagination-wrapper {
  margin-top: 16px;
  text-align: right;
}
</style>
